import { render } from "./CompanyCard.vue?vue&type=template&id=138d406c&scoped=true"
import script from "./CompanyCard.vue?vue&type=script&lang=js"
export * from "./CompanyCard.vue?vue&type=script&lang=js"

import "./CompanyCard.vue?vue&type=style&index=0&id=138d406c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-138d406c"]])

export default __exports__